import { NodeTypes } from '@marvr/storyblok-rich-text-types'

export function useHasContent(data: any): boolean {
  if (!data?.content)
    return false
  return !!data?.content[0]?.content
}

export function useGetBulletListItems(data: any): Array<BulletListData> {
  const bulletListItems: Array<BulletListData> = []
  data?.content.forEach((element: any) => {
    if (element?.type === 'bullet_list') {
      element?.content.forEach((textBlock: any) => {
        bulletListItems.push({
          text: textBlock?.content[0]?.content[0]?.text,
        })
      })
    }
    else if (element?.type === 'blok' && element?.attrs?.body[0].component === 'RichtextTooltip') {
      bulletListItems.push({
        text: element?.attrs?.body[0].text?.content[0]?.content[0]?.text,
        tooltip: element?.attrs?.body[0].tooltip[0],
      })
    }
  })
  return bulletListItems
}

export function useCreateRichtextRootNode(
  content: Array<{
    text: string | number
    type: NodeTypes
    marks?: Array<{
      type: NodeTypes
    }>
  }>,
) {
  return {
    text: {
      content: [{
        content,
        type: NodeTypes.PARAGRAPH,
      }],
      type: NodeTypes.DOCUMENT,
    },
  }
}
